<template>
  <div class="question-content">
    <nav>
      <li v-for="(item, index) in showQuestionList" :key="index">
        <div v-if="item.question_title_uuid === '' " class="content">
          <!-- 知识点 -->
          <span class="content__title"
            v-for="(Kitem, kindex) in item.knowledge"
            :key="kindex">{{ Kitem.tag_name }}</span>
            <!-- 题干 -->
          <div class="content__count">
            <p>{{ item.num }}、</p>
            <p v-if="type" v-katexHtml="item.content.content" />
            <p v-katexUbb="htmlDeCode(item.content.content)" v-else />
          </div>
          <!-- 英语听力 -->
          <div
            class="content__audio"
            v-if="
              item.content &&
              item.content.hearing &&
              item.content.hearing[0] &&
              item.content.hearing[0].source
            "
            @click="controlAudio(item.question_id)"
          >
            <p
              class="audio-pause"
              :class="
                isAudioPlaying && currentQuestionUuid === item.question_uuid
                  ? 'voice-playing'
                  : ''
              "
            ></p>
            <audio
              ref="audio"
              :id="`audio${item.question_id}`"
              :src="item.content.hearing[0].source"
              @pause="onPause"
              @play="onPlay"
            />
          </div>
          <!-- 判断题 -->
            <div
            v-if="item.question_type === 3 && item.show_type  === '103'"
            class="content__option"
          >
            <div
              v-for="(oitem, oindex) in Number(subject_id) === 1
                ? enText
                : cnText"
              :key="oindex"
            >
              <p>{{ oitem }}</p>
            </div>
          </div>
          <!-- 所有选项 -->
          <div class="question-analysis__option">
            <div v-for="(oitem, oindex) in item.options" :key="oindex">
              <p>{{ oitem.key }}：</p>
              <p v-katexHtml="oitem.content"></p>
            </div>
          </div>
          <!-- 选词填空 -->
          <div
            v-if="
              item &&
              item.question_type === 6
            "
            class="content__option"
          >
            <div
              v-for="(oitem, oindex) in item.choice_words"
              :key="oindex"
            >
              <p v-katexUbb="htmlDeCode(oitem.content)"></p>
            </div>
          </div>
          <!-- 非题冒题 -->
          <div class="content__footer">
            <div>
              <p>
                <span>题型: </span>
                <span>{{ questionName(
                      item.question_type,
                      item.show_type,
                      item.question_title_uuid,) || item.question_type_name }}</span>
              </p>
              <p>
                <span>难度: </span>
                <span>{{ item.difficulty }}</span>
              </p>
              <p>
                <span>答题次数: </span>
                <span>{{ item.total }}</span>
              </p>
              <p>
                <span>正答率: </span>
                <span>{{ item.right_rate }}%</span>
              </p>
            </div>
            <div class="footer__right">
              <p
                class="tickling pointer"
                @click="submitAnalysis(item.question_uuid)"
                v-if="!isPad"
              >
                反馈
              </p>
              <p class="analysis pointer">
                <span
                  v-if="item.active"
                  style="margin-left: 6px"
                  @click="closeAnalysis(item)"
                  >收起解析</span
                >
                <span
                  v-else
                  style="margin-left: 6px"
                  @click="openAnalysis(item)"
                  >查看解析</span
                >
              </p>
              <p
                class="putOut pointer"
                @click="PutOutBasket(item)"
                v-if="includesThisQuestion(item) && type"
              >
                移除
              </p>
              <button class="basket" @click="PutInBasket(item)"
              v-if="!includesThisQuestion(item) && exerciseType && type">
                <span class="basket-content">选入试题篮</span>
              </button>
            </div>
          </div>
        </div>
        <div v-else>
          <!-- 题冒题 -->
          <ul>
            <li class="content">
              <div class="content__count">
                <div v-if="item.title_question
                && item.title_question.content">
                <el-popover
                  placement="right"
                  popper-class="popover"
                  title=""
                  width="600"
                  trigger="click"
                  >
                  <p v-if="type" v-katexHtml="item.title_question.content.content"></p>
                  <p
                    v-katexUbb="htmlDeCode(item.title_question.content.content)"
                    v-else />
                    <!-- 英语听力 -->
                  <div
                    class="content__audio"
                    v-if="
                      item.title_question &&
                      item.title_question.content &&
                      item.title_question.content.hearing&&
                      item.title_question.content.hearing[0] &&
                      item.title_question.content.hearing[0].source
                    "
                    @click="controlAudio(item.question_id)"
                  >
                    <p
                      class="audio-pause"
                      :class="
                        isAudioPlaying && currentQuestionUuid === item.question_uuid
                          ? 'voice-playing'
                          : ''
                      "
                    ></p>
                    <audio
                      ref="audio"
                      :id="`audio${item.question_id}`"
                      :src="item.title_question.content.hearing[0].source"
                      @pause="onPause"
                      @play="onPlay"
                    />
                  </div>
                  <p slot="reference" class="pointer title-uuid">查看原文</p>
                </el-popover>
                  <p style="display: inline-block;">{{ index + 1 }}、</p>
                  <p style="display: inline-block;"
                  v-katexUbb="htmlDeCode(item.content.content)" />
                </div>
              </div>
              <!-- 选词填空 -->
              <div
                v-if="
                  item &&
                  item.question_type === 6 &&
                  item.show_type === '112'
                "
                class="content__option"
              >
                <div v-for="(oitem, oindex) in item.choice_words" :key="oindex">
                  <p v-katexUbb="htmlDeCode(oitem.content)"></p>
                </div>
              </div>
              <!-- 判断题 -->
              <div
                v-if="
                  item &&
                  item.question_type === 3 &&
                  item.show_type === '103'
                "
                class="content__option"
              >
                <div v-for="(oitem, oindex) in Number(subjectId) === 1
                ? enText
                : cnText" :key="oindex">
                  <p>{{ oitem }}</p>
                </div>
              </div>
              <div class="content__option" v-else>
                <div v-for="(oitem, oindex) in item.options"
                :key="oindex">
                  <p>{{ oitem.key }}：</p>
                  <p v-katexHtml="oitem.content"></p>
                </div>
              </div>
              <div class="content__footer">
            <div>
              <p>
                <span>题型: </span>
                <span>{{ questionName(
                      item.question_type,
                      item.show_type,
                      item.question_title_uuid,) }}</span>
              </p>
              <p>
                <span>难度: </span>
                <span>{{ item.difficulty }}</span>
              </p>
              <p>
                <span>正答率: </span>
                <span>{{ item.right_rate }}%</span>
              </p>
            </div>
            <div class="footer__right">
              <p
                class="tickling pointer"
                @click="submitAnalysis(item.question_uuid)"
                v-if="!isPad"
              >
                反馈
              </p>
              <p class="analysis pointer">
                <span
                  v-if="item.active"
                  style="margin-left: 6px"
                  @click="closeAnalysis(item)"
                  >收起解析</span
                >
                <span
                  v-else
                  style="margin-left: 6px"
                  @click="openAnalysis(item)"
                  >查看解析</span
                >
              </p>
              <p
                class="putOut pointer"
                @click="PutOutBasket(item)"
                v-if="includesThisQuestion(item) && exerciseType && type"
              >
                移除
              </p>
              <button class="basket" @click="PutInBasket(item)"
              v-if="!includesThisQuestion(item) && exerciseType && type">
                <span class="basket-content">选入试题篮</span>
              </button>
            </div>
          </div>
            </li>
          </ul>
        </div>
        <!-- 展开解析 -->
        <ul class="question-analysis" v-if="item.active">
          <li class="question-analysis__answer">
            <span style="min-width: 110px">正确答案:</span>
            <!-- 理科正确答案 -->
            <div v-if="type">
              <div v-if="item.question_type !== 3">
                <span
                  v-for="(aitem, aindex) in item.answer"
                  :key="aindex"
                  class="right-answer"
                  v-katexHtml="aitem"
                ></span>
              </div>
              <div v-else class="completion">
                <div v-for="(aitem, aindex) in item.answer" :key="aindex">
                  <div
                    v-for="(childItem, childIndex) in aitem"
                    :key="childIndex"
                  >
                    <span
                      v-katexHtml="childItem.content"
                      class="right-answer"
                    ></span>
                  </div>
                </div>
              </div>
            </div>
            <!-- 文科 -->
            <div v-else>
              <p v-if="item.question_type !== 3 && item.question_type !== 6 ">
              <span
                v-for="(aitem, aindex) in item.answer"
                :key="aindex"
                class="right-answer"
                v-katexUbb="htmlDeCode(aitem)"
              ></span>
              </p>
              <div v-else class="completion">
                <div v-if="item.question_type === 3 && (item.show_type === '103'
                || item.show_type)">
                  <div
                    v-for="(aitem, aindex) in item.answer"
                    :key="aindex"
                    class="right-answer">
                      <span v-if="Number(subjectId) === 3">
                        {{ aitem.content === "T" ? "正确" : "错误" }}
                      </span>
                      <span v-else>
                        {{ aitem.content === "T" ? "True" : "False" }}
                      </span>
                  </div>
                </div>
                <div v-else v-for="(aitem, aindex) in item.answer" :key="aindex">
                  <div v-for="(childItem, childIndex) in aitem" :key="childIndex">
                    <span
                      v-katexUbb="htmlDeCode(childItem.content)"
                      class="right-answer"
                    ></span>
                  </div>
                </div>
              </div>
            </div>
          </li>
          <li>
            <!-- 单选错误答案 -->
            <ul v-if="item.question_type !== 3">
              <li class="error">
                <div class="error-label">
                  作答情况:
                </div>
                <div class="fx">
                  <div
                  v-for="(kitem, index) in item.detailsList"
                  :key="index"
                  class="error-answer">
                  <span class="mr">选项[{{kitem.answer !== '' ?
                      kitem.answer : '未作答'}}]</span>
                  <span class="mr">占{{kitem.error_than}}%</span>
                  <div style="width: 80%">
                    <el-progress
                    :percentage="kitem.error_than"
                    :color="customColor"></el-progress>
                  </div>
                    <i v-if="!kitem.isShow"
                      class="el-icon-arrow-down"
                      @click="openStudent(kitem)"></i>
                      <i v-else class="el-icon-arrow-up" @click="openStudent(kitem, true)"></i>
                      <div div v-if="kitem.isShow" class="error-student">
                        <i class="el-icon-caret-top top"></i>
                      {{Object.values(kitem.student_list).join('  |  ')}}
                      </div>
                  </div>
                </div>
              </li>
            </ul>
            <!-- 填空题错误答案渲染 -->
            <el-table
              v-else
              :data="item.detailsList"
              style="width: 90%">
              <el-table-column
                prop="answer"
                label="错误答案">
                <template slot-scope="scope">
                <!-- 理科错题 -->
                  <div v-if="scienceArr.includes(Number(subjectId))">
                    <div v-if="scope.row.answer.length < 1">
                      跳过此题
                    </div>
                    <span
                      v-else
                      style="margin-left: 4px"
                      >
                      <span v-if="!isNaN(scope.row.answer)"> {{scope.row.answer}}</span>
                      <span v-for="(nitem, nindex) in scope.row.answer"
                      :key="nindex" v-else v-katexHtml="nitem"></span>
                    </span>
                  </div>
                  <!-- 文科错题 -->
                  <div v-else>
                    <div v-if="item.question_type === 3 && item.show_type === '103'">
                      <div
                        v-for="(uitem, uindex) in scope.row.answer"
                        :key="uindex"
                        class="right-answer">
                        <div v-if="uitem !== ''">
                          <span v-if="Number(subjectId) === 3">
                            {{ uitem === "T" ? "正确" : "错误" }}
                          </span>
                          <span v-else>
                            {{ uitem === "T" ? "True" : "False" }}
                          </span>
                        </div>
                        <div v-else>
                          未作答
                        </div>
                      </div>
                    </div>
                    <div v-else>
                      <span
                        v-for="(uitem, index) in scope.row.answer"
                        :key="index">
                        <span v-if="uitem !== ''" v-katexUbb="htmlDeCode(uitem)"></span>
                        <span v-else> 未作答 </span>
                    </span>
                    </div>
                  </div>
              </template>
              </el-table-column>
              <el-table-column
                prop="num"
                align="center"
                label="回答次数">
              </el-table-column>
              <el-table-column
                prop="error_than"
                align="center"
                label="占比数据">
                <template slot-scope="scope">
                <div>
                  {{ scope.row.error_than }}%
                </div>
              </template>
              </el-table-column>
              <el-table-column
                prop="student_list"
                align="center"
                width="500"
                label="学生明细">
                <template slot-scope="scope">
                  <span>
                    {{getPerson(scope.row.student_list)}}
                  </span>
                </template>
              </el-table-column>
            </el-table>
          </li>
          <li class="question-analysis__text"
            v-if="item.analyze &&
              item.analyze[0]  &&
              item.analyze[0].content &&
              item.analyze[0].content[0] &&
              item.analyze[0].content[0].content !== '' ||
              (item.analyze &&
              item.analyze[0] &&
              item.analyze[0].title !== '')">
            <span style="min-width: 110px">文字解析:</span>
            <!-- 理科 -->
            <div v-if="type">
              <div
                v-for="(zitem, zindex) in item.analyze"
                :key="zindex"
                class="text-content"
              >
                <span v-katexHtml="zitem.title"></span>
                <span v-katexHtml="zitem.content[0] &&zitem.content[0].content"></span>
              </div>
            </div>
            <div v-else>
              <div
                v-for="(zitem, zindex) in item.analyze"
                :key="zindex"
                class="text-content"
              >
                <span v-katexUbb="htmlDeCode(zitem.title)"></span>
                <span v-katexUbb="htmlDeCode(zitem.content[0] && zitem.content[0].content)"></span>
              </div>
            </div>
          </li>
          <li
            class="question-analysis__videos"
            v-if="item.question_source && item.question_source.length > 0"
          >
            <p>视频解析:</p>
            <p
              class="video-content"
              @click.stop="videoOpen(item.question_source[0].source_url)"
            >
              <span>播放</span>
            </p>
          </li>
        </ul>
      </li>
    </nav>
    <div v-if="showQuestionList.length < 1" class="empty">
      <img src="../../images/emptyType.png" alt="" />
    </div>
    <!-- 分页 -->
    <!-- <el-pagination
      background
      layout="total, sizes, prev, pager, next, jumper"
      :total="totalCount"
      :page-size="pageSize"
      :page-sizes="[10, 20, 50, 100]"
      :current-page="currentPage"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    >
    </el-pagination> -->
    <!-- 反馈弹框 -->
    <analysis-dialog
      :centerDialogVisible.sync="centerDialogVisible"
      :questionUUid="questionUUid"
    />
    <!-- 视频弹框 -->
    <video-dialog :dialogVisible.sync="dialogVisible" :videoUrl="videoUrl" />
  </div>
</template>
<script>
import { evaluateQuestionDetails, getQuestionDetails } from '@/api/pt';
import analysisDialog from '../../lesson-prepare/components/analysis-dialog.vue';
import videoDialog from '../../lesson-prepare/components/video-dialog.vue';
import _ from 'lodash';
import { htmlDecodeByRegExp } from '@/utils';

export default {
  name: 'HighQuestionContent',
  props: {
    totalCount: {
      type: Number,
      default: 0,
    },
    subjectId: {
      type: [String, Number],
    },
    exerciseType: {
      type: [Boolean, String],
    },
    questionList: {
      type: Array,
      default: () => [],
    },
    fromPage: {
      type: String,
      default: 'FromSyncTest',
    },
    searchForm: {
      type: Object,
      default: () => {},
    },
    formedTargets: {
      type: Object,
      default: () => {},
    },
    type: {},
    classId: {},
  },
  components: {
    analysisDialog,
    videoDialog,
  },
  watch: {
    questionList: {
      handler() {
        this.showQuestionList = this.questionList;
      },
      immediate: true,
    },
  },
  data() {
    return {
      // total: 0, // 总数
      scienceArr: [2, 4, 5],
      cnText: ['正确', '错误'],
      enText: ['True', 'False'],
      isAudioPlaying: false,
      isPad: this.$route.query.spad,
      // pageSize: 10,
      // currentPage: 1,
      centerDialogVisible: false,
      dialogVisible: false,
      questionUUid: '',
      videoUrl: '',
      questionsBasket: [],
      currentQuestionid: '',
      showQuestionList: [],
      detailsList: [],
      customColor: '#F56C6C',
    };
  },
  computed: {
    videoType() {
      return function video(val) {
        if (val) {
          val.some((item) => item.video_data.length > 0);
        }
      };
    },
    includesThisQuestion() {
      const { questionsBasket } = this.$store.state;
      return function includesThisQuestion(val) {
        const str = questionsBasket.some((item) => item.question_uuid === val.question_uuid);
        if (str) {
          return true;
        }
        return false;
      };
    },
  },
  methods: {
    getPerson(obj) {
      console.log(obj, 'obj');
      const person = Object.values(obj).join('、');
      return person;
    },
    questionName(question, show) {
      let name = '';
      if (question === 1 && show === '100') {
        name = '单选题';
      } else if (question === 2 && show === '101') {
        name = '多选题';
      } else if (question === 3 && show === '102') {
        name = '填空题';
      } else if (question === 3 && show === '103') {
        name = '判断题';
      } else if (question === 6 && show === '112') {
        name = '选词填空';
      }
      return name;
    },
    // 音频播放状态
    onPlay() {
      console.log('音频开始播放了');
      this.isAudioPlaying = true;
    },
    // 转换html字符串
    htmlDeCode(str) {
      return htmlDecodeByRegExp(str, 1);
    },
    hide() {
      if (this.$refs.audio) {
        this.$refs.audio.forEach((item) => {
          item.pause();
        });
      }
    },
    // 音频暂停状态
    onPause() {
      console.log('音频暂停了');
      this.isAudioPlaying = false;
    },
    controlAudio(index) {
      const id = `audio${index}`;
      if (this.currentQuestionUuid === index && this.isAudioPlaying) {
        this.isAudioPlaying = false;
        this.$refs.audio.forEach((item) => {
          if (item.id === id) {
            item.pause();
          }
        });
      } else if (this.currentQuestionUuid === index && !this.isAudioPlaying) {
        this.isAudioPlaying = true;
        this.$refs.audio.forEach((item) => {
          if (item.id === id) {
            item.play();
          }
        });
      } else if (this.currentQuestionUuid !== index && !this.isAudioPlaying) {
        this.currentQuestionUuid = index;
        this.isAudioPlaying = true;
        this.$refs.audio.forEach((item) => {
          if (item.id === id) {
            item.play();
          } else {
            item.pause();
          }
        });
      } else if (this.currentQuestionUuid !== index && this.isAudioPlaying) {
        this.currentQuestionUuid = index;
        this.$refs.audio.forEach((item) => {
          if (item.id === id) {
            item.play();
          } else {
            item.pause();
          }
        });
      }
    },
    videoOpen(val) {
      this.dialogVisible = true;
      this.videoUrl = val;
    },
    submitAnalysis(uuid) { // 反馈
      this.questionUUid = uuid;
      this.centerDialogVisible = true;
    },
    openAnalysis(item) {
      this.$set(item, 'active', true);
      this.currentQuestionid = item.question_uuid;
      this.evaluateQuestionDetails(item);
    },
    closeAnalysis(item) {
      this.$set(item, 'active', false);
    },
    PutInBasket(question) {
      if (!this.includesThisQuestion(question)) {
        this.$set(question, 'active', false);
        this.$store.commit('PUTIN_QUESTIONS_BASKET', question);
      } else {
        this.$message({
          message: '此题已存在',
          type: 'warning',
        });
      }
    },
    parse(v) {
      let ret = v;
      try {
        ret = JSON.parse(ret);
      } catch (e) {
        // console.log(e);
      }
      return ret;
    },
    PutOutBasket(question) {
      if (this.fromPage === 'FromBasket') {
        this.showQuestionList.splice(question, 1);
      }
      this.$store.commit('PUTOUT_QUESTIONS_BASKET', question);
    },
    async evaluateQuestionDetails(item) { // 列表接口
      const userInfo = JSON.parse(localStorage.getItem('CRM_USER_INFO') || '{}');
      const params = {
        class_id: this.searchForm.class_id,
        question_id: item.question_uuid,
        start_time: this.searchForm.startDate,
        end_time: this.searchForm.endDate,
        school_id: userInfo.campusId,
        subject_id: this.subjectId,
      };
      if (this.exerciseType) {
        await getQuestionDetails(params).then((res) => {
          if (res.code === 200) {
            const analyzes = _.get(res.data.question_detail, 'analyze');
            const questionSource = _.get(res.data.question_detail, 'question_source');
            this.$set(item, 'analyze', analyzes);
            this.$set(item, 'question_source', questionSource);
            this.detailsList = (res.data.answer_detail || [])
              .map((v) => ({
                ...v,
                answer: this.parse(v.answer),
              }));
            console.log(this.detailsList.answer, 'detailsList', this.detailsList);
            this.detailsList.forEach((k) => {
              this.$set(k, 'isShow', false);
            });
            this.$set(item, 'detailsList', this.detailsList);
          }
        });
      } else {
        await evaluateQuestionDetails(params).then((res) => {
          if (res.code === 200) {
            const analyzes = _.get(res.data.question_detail, 'analyze');
            const questionSource = _.get(res.data.question_detail, 'question_source');
            this.$set(item, 'analyze', analyzes);
            this.$set(item, 'question_source', questionSource);
            this.detailsList = res.data.answer_detail;
            this.detailsList.forEach((k) => {
              this.$set(k, 'isShow', false);
            });
            this.$set(item, 'detailsList', this.detailsList);
          }
        });
      }
    },
    openStudent(item, type) {
      if (type) {
        this.$set(item, 'isShow', false);
      } else {
        this.$set(item, 'isShow', true);
      }
    },
    // handleSizeChange(v) {
    //   this.pageSize = v;
    //   this.$emit('changePage', this.pageSize, true);
    // },
    // handleCurrentChange(v) {
    //   this.currentPage = v;
    //   this.$emit('changePage', this.currentPage);
    // },
  },
};
</script>
<style lang="scss" scoped>
.question-content {
  min-height: 500px;
  width: 100%;
  position: relative;
  .content {
    min-height: 148px;
    border: 3px solid rgba(118, 194, 255, 0.14);
    border-radius: 12px;
    padding-top: 17px;
    margin-left: 28px;
    margin-top: 28px;
    box-sizing: border-box;
    position: relative;
    overflow: hidden;
    &__title {
      padding: 5px;
      margin-left: 25px;
      display: inline-block;
      min-width: 89px;
      height: 24px;
      background: #f0f2f5;
      border-radius: 3px;
      border: 1px solid #d7dfec;
      font-size: 13px;
      color: #5a5e66;
      text-align: center;
      line-height: 24px;
    }
    &__count {
      margin: 16px 0;
      width: 584px;
      font-size: 15px;
      padding: 0 25px;
      color: #111f2c;
      line-height: 21px;
      display: flex;
    }
    &__option {
      display: flex;
      justify-content: space-evenly;
      align-items: center;
      border-bottom: 1px dashed #dce1eb;
      padding-bottom: 3px;
      font-size: 14px;
      div {
        display: flex;
        align-items: center;
      }
    }
    &__footer {
      width: 100%;
      height: 52px;
      line-height: 52px;
      display: flex;
      padding-left: 25px;
      box-sizing: border-box;
      justify-content: space-between;
      background: url("../../images/footerbg.png") no-repeat;
      background-size: 100% 100%;
      div {
        display: flex;
        align-items: center;
        p {
          margin-right: 20px;
          font-size: 14px;
        }
      }
      .footer__right {
        color: #1989fa;
        font-size: 14px;
        .basket {
          display: inline-block;
          width: 108px;
          height: 32px;
          background: #1989fa;
          border-radius: 6px;
          line-height: 32px;
          text-align: center;
          color: #ffffff;
          margin-right: 20px;
          &.includes {
            background: #ffffff;
            color: #1989fa;
          }
          .basket-content {
            font-size: 14px;
            box-sizing: border-box;
            padding-left: 15px;
            background: url("../../images/add_witle.png") no-repeat left center;
            background-size: 12px 12px;
            &.includes {
              padding: 0px;
            }
          }
        }
        .tickling {
          background: url("../../images/feedback.png") no-repeat left center;
          background-size: 13px 17px;
          text-indent: 18px;
        }
        .analysis {
          background: url("../../images/examine-analysis.png") no-repeat left
            center;
          background-size: 13px 15px;
          text-indent: 18px;
        }
        .putOut {
          background: url("../../images/delete.png") no-repeat 20px center;
          background-size: 13px 15px;
          // text-indent: 18px;
          font-size: 14px;
          width: 108px;
          text-align: center;
        }
      }
    }
  }
  .question-analysis {
    margin-left: 48px;
    margin-right: 20px;
    min-height: 219px;
    border: 3px solid rgba(118, 194, 255, 0.14);
    border-radius: 12px;
    padding: 15px 20px;
    &__option {
      display: flex;
      justify-content: space-evenly;
      align-items: center;
      border-bottom: 1px dashed #dce1eb;
      padding-bottom: 20px;
      font-size: 14px;
      div {
        display: flex;
        align-items: center;
      }
    }
    &__answer {
      font-size: 15px !important;
      color: #000000;
      line-height: 53px;
      border-bottom: 1px dashed #dce1eb;
      display: flex;
      .completion {
        display: flex;
        align-items: center;
      }
      .right-answer {
        display: flex;
        justify-content: flex-start;
        color: #67c23a;
        margin-right: 10px;
        font-size: 15px !important;
      }
    }
    &__text {
      font-size: 15px;
      min-width: 120px;
      color: #000000;
      line-height: 53px;
      display: flex;
      .text-content {
        margin-top: 15px;
        p {
          line-height: 24px;
        }
      }
    }
    &__videos {
      margin-top: 17px;
      border-top: 1px dashed #dce1eb;
      font-size: 15px;
      color: #000000;
      height: 53px;
      display: flex;
      align-items: center;
      .video-content {
        display: inline-block;
        width: 84px;
        height: 28px;
        background: #ffa82d;
        border-radius: 14px;
        margin-left: 45px;
        line-height: 28px;
        span {
          font-size: 16px;
          display: inline-block;
          background: url("../../images/play_video.png") no-repeat left center;
          background-size: 24px 24px;
          box-sizing: border-box;
          padding-left: 32px;
          text-align: center;
          margin-left: 2px;
          color: #ffffff;
        }
      }
    }
  }
  .empty {
    img {
      width: 209px;
      height: 147px;
      position: relative;
      left: 50%;
      transform: translateX(-50%);
      margin-top: 30px;
    }
  }
  /deep/ .el-pagination {
    display: flex;
    position: absolute;
    padding-top: 20px;
    // width: calc(100% - 64px);
    bottom: -40px;
    left: 30px;
    .btn-prev {
      margin-left: auto;
    }
  }
  .error {
    display: flex;
    margin-top: 10px;
    font-size: 16px;
    &-label {
      width: 110px;
      font-size: 18px;
      font-weight: 500;
    }
    .mr {
      margin-right: 10px;
    }
    &-student {
      margin-top: 15px;
      position: relative;
      min-width: 400px;
      max-width: 700px;
      line-height: 24px;
      padding: 18px 20px;
      border: 1px solid #ebeef5;
      border-radius: 4px;
      background-color: #fff;
      box-shadow: 0 2px 2px 0 ;
      word-break: break-all;
      .top  {
        position: absolute;
        color: #ccc;
        font-size: 20px;
        top: -13px;
      }
    }
    &-answer {
      flex: 1;
      display: flex;
      flex-wrap: wrap;
      margin: 15px;
      /deep/ {
        .el-progress {
          flex: 1;
        }
        .el-icon-arrow-up:before {
          content: "\e6e1";
        }
      }
    }
  }
  .fx {
    flex: 1;
  }
}
.content__audio {
      margin-left: 25px;
      margin-bottom: 16px;
      width: 36px;
      height: 36px;
      border-radius: 50%;
      background: #f7ca08;
      .audio-pause {
        width: 36px;
        height: 36px;
        // border-radius: 50%;
        background: url("../../images/audio_pause.png") no-repeat center center;
        background-size: 22px 15px;
        &.voice-playing {
          background: url("../../images/audio_playing.gif") no-repeat center
            center;
          background-size: 22px 15px;
        }
      }
    }
</style>
